var map = {
	"./photo-1-1.jpg": "b765",
	"./photo-2-1.jpg": "9e0c",
	"./photo-3-1.jpg": "4287",
	"./photo-4-1.jpg": "9402",
	"./photo-5-1.jpg": "5abe",
	"./photo-6-1.jpg": "aefd",
	"./photo-7-1.jpg": "3cea",
	"./photo-8-1.jpg": "e9ba",
	"./photo-9-1.jpg": "96b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1454";